import { render, staticRenderFns } from "./FuWu.vue?vue&type=template&id=5c2015d0&scoped=true&"
import script from "./FuWu.vue?vue&type=script&lang=js&"
export * from "./FuWu.vue?vue&type=script&lang=js&"
import style0 from "./FuWu.vue?vue&type=style&index=0&id=5c2015d0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2015d0",
  null
  
)

export default component.exports